import { Injectable } from '@angular/core';
import { environment } from '@rtls-environment/environment';
import { RtlsModels } from '@rtls/core/models/rtls/rtls-models';
import { RtlsServiceDecorator } from '@rtls/core/models/rtls/rtls-service.decorator';
import { RtlsService } from '@rtls/core/models/rtls/rtls-service.model';
import { Step } from '@rtls/core/models/thing/step.model';

@Injectable()
export class StepLocationService extends RtlsServiceDecorator<Step> {
	constructor(rtlsService: RtlsService<Step>) {
		super(rtlsService.useModel(RtlsModels.StepLocation, environment.thingsApi));
	}

	rewriteEverything() {
		return this.customDownload('rewrite/everything');
	}
}
